import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Package } from 'types/package';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface PackageItemProps {
  option: Package;
  selected: Package | null;
  handleSelect(pkg: Package): void;
}

const PackageItem: React.FC<PackageItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default PackageItem;
